export interface OrderStockHistory {
  productID: number;
  productName: string;
  optionValueID?: string;
  optionValueName?: string;
  oldStock: number;
  newStock: number;
}

export const orderStockHistoryFromResponse = (
  responseData: any,
): OrderStockHistory => ({
  productID: responseData.product_id,
  productName: responseData.product_name,
  optionValueID: responseData.option_value_id,
  optionValueName: responseData.option_value_name,
  oldStock: responseData.old_stock,
  newStock: responseData.new_stock,
});
